
import {
    useABI_testcon
} from '@/contacthelp/useContract.js';
const { hexToBytes,asciiToHex} = require('web3-utils');

export function gettestcon(library, account, chainID){
    const address = '0xb60a88f58c20c9148552a5fec1bdc656c58cfdf2';
    const Contract = useABI_testcon(library,
        account,
        address,
        true);
    return Contract;

}


export async function depositToken(library, account, chainID,args){
    const con =  gettestcon(library, account, chainID);
    console.log('con',con);
    const res= await con[args.methods](args.to,args.amount,hexToBytes(asciiToHex(args.uid)));
    return res;

}



/**
 * export function getMyNftcontract(library, account, chainID,nftaddress) {
    console.log('getArtcontract');
    const address = nftaddress||getTokenByName(chainID,'MyNFT');
    const Contract = useABI_ERC21_MyNFT(library,
        account,
        address,
        true);
    return Contract;

}
 * **/